import { render, staticRenderFns } from "./FAQList.vue?vue&type=template&id=6156e798&scoped=true&"
import script from "./FAQList.vue?vue&type=script&lang=ts&"
export * from "./FAQList.vue?vue&type=script&lang=ts&"
import style0 from "./FAQList.vue?vue&type=style&index=0&id=6156e798&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6156e798",
  null
  
)

export default component.exports